<template lang="pug">
  v-container(fluid)
    Edit(:editDialog="editDialog" :editData="editData" @close="editDialog = false" @getList="loadData()")
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('labels.filters') }}
        v-spacer
        v-tooltip.ml-1.pointer(bottom)
          template(slot='activator')
            v-btn(flat @click="reset" icon)
              v-icon autorenew
          span Reset
        v-tooltip.ml-1.pointer(bottom)
          template(slot='activator')
            v-btn(flat @click="reloadData" icon)
              v-icon refresh
          span Fetch Data
      v-card-text
        v-layout(row wrap)
          v-flex(xs12)
            VueCtkDateTimePicker(v-model='setDate' label="Select Date Range" range @input="setDateTime" overlay)
    v-card.mt-2
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('pageHeader.feedback') }}
      v-card-title
        v-flex(xs12 sm4)
          v-text-field(v-model='search', append-icon='search', label='Search', single-line, hide-details clearable)
      v-data-table(:headers='headers' item-key="feedbackID" :items='feedback' :search="search" :loading='loading' :pagination.sync='pagination')
          template(slot='items' slot-scope='props')
            tr.pointer
              td.text-xs-left(@click="props.expanded = !props.expanded")
                v-icon.mr-2(small v-if="props.item.favorite" color="red") favorite
                v-icon.mr-2(small v-else) favorite_border
                | {{ $moment(props.item.createdAt).format('M/D/YY') }}
              td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.Store.CSPID }}
              td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.Store.businessName }}
              td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.contactName }}
              td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.phoneNumber | USPhoneNumber }}
              td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.User.fullName }}
              
          template(slot='expand' slot-scope='props')
            v-card
              v-card-text
                v-layout(row wrap)
                  v-flex(xs12 sm6)
                    h3.font-weight-regular.mb-3
                      v-icon.mr-2(v-if="props.item.favorite" color="red") favorite
                      v-icon.mr-2(v-else) favorite_border
                      | Feedback
                    div {{ $t('labels.createdAt') }}
                    div.font-weight-medium {{ props.item.createdAt | moment('dddd, MMMM Do YYYY h:m a')  }}                    
                    div.mt-1 {{ $t('labels.talkAbout') }}
                    div.font-weight-medium {{ props.item.talkAbout }} 
                    div.mt-1 {{ $t('labels.createdBy') }}
                    div.font-weight-medium {{ props.item.User.fullName }}                    
                  v-flex(xs12 sm6)
                    h3.font-weight-regular.mb-3 Contact
                    div.mt-1 {{ $t('labels.name') }}
                    div.font-weight-medium {{ props.item.contactName }}
                    div.mt-1 {{ $t('labels.phoneNumber') }}
                    div.font-weight-medium {{ props.item.phoneNumber}}
                    div.mt-1 {{ $t('labels.rating') }}
                    div.font-weight-medium {{ props.item.rating }}
                  v-layout(row wrap)
                    v-btn(color="info" @click="gotoPage(props.item)") View Store Page
                    v-spacer
                    v-btn(color="pink" dark icon @click='edit(props.item)')
                      v-icon(small) edit 
                    v-btn(color="red" dark icon @click='deleteFeedback(props.item)')
                      v-icon(small) delete 
          v-alert(slot='no-results', :value='true', color='error', icon='warning')
            | Your search for "{{ search }}" found no results.
      

</template>

<script>
import feedbackService from "../service.js";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Edit from "./Edit";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      setDate: {
        start: this.$moment(new Date()).subtract(7, 'days').format("YYYY-MM-DD"),
        end: this.$moment(new Date()).format("YYYY-MM-DD")
      },
      filter: {
        fromDate: this.$moment(new Date()).subtract(7, 'days'),
        toDate: this.$moment(new Date())
      },
      expand: false,
      editDialog: false,
      editData: {},
      headers: [
        {
          text: this.$t("labels.createdAt"),
          value: "createdAt",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.cspid"),
          value: "Store.CSPID",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.businessName"),
          value: "Store.businessName",
          sortable: true,
        },
        {
          text: this.$t("labels.contactName"),
          value: "contactName",
          sortable: true,
          width: "15%"
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "phoneNumber",
          sortable: true,
          width: "15%"
        },
        {
          text: this.$t("labels.createdBy"),
          value: "User.fullName",
          sortable: true,
          width: "15%"
        }
      ],
      search: null,
      feedback: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "feedbackID",
        descending: true
      }
    };
  },
  components: {
    Edit,
    VueCtkDateTimePicker
  },
  created() {
    this.getList()
  },
  methods: {
    gotoPage(data) {
      console.log('store', data)
      this.$router.push({ path: `/location/profile/${data.Store.storeID}` })
    },
    setDateTime(val) {
      this.filter.fromDate = val.start
      this.filter.toDate = val.end
    },
    reset() {
      this.resetList()
      this.getList()
    },
    resetList() {
      this.filter.fromDate = this.$moment(new Date()).subtract(7, 'days')
      this.filter.toDate = this.$moment(new Date())
    },
    reloadData() {
      this.loading = true
      let proFilter = {}
      if (this.filter.fromDate)
        proFilter.fromDate = this.$moment(this.filter.fromDate).format("MM/DD/YYYY h:m a")
      if (this.filter.toDate) 
        proFilter.toDate = this.$moment(this.filter.toDate).format("MM/DD/YYYY h:m a")
      
      return feedbackService.getAll(proFilter).then(response => {
        this.feedback = response.feedback.data;
        this.loading = false
        return response
      })
    },
    deleteFeedback(data) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete this feedback?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return feedbackService
            .delete(data.feedbackID)
            .then(response => {
              if (response.data) {
                this.$swal("Deleted!", "Record has been deleted.", "success");
              }
              this.$Progress.finish();
              this.getList();
            })
            .catch(error => {
              this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
              }).fire({
                type: 'error',
                title: error.data.message
              })
              this.$Progress.fail();
            });
        }
      });
    },
    edit(data) {
      this.editData = data;
      this.editDialog = true;
    },
    getList() {
      this.loading = true;
      let proFilter = {
        fromDate:this.$moment(this.filter.fromDate).format("MM/DD/YYYY h:m a"),
        toDate: this.$moment(this.filter.toDate).format("MM/DD/YYYY h:m a")
      }
      return feedbackService.getAll(proFilter).then(response => {
        this.feedback = response.feedback.data;
        this.loading = false;
        return response;
      });
    },
    getListByStore() {
      this.loading = true;
      // console.log('this.location', this.location)
      return feedbackService.getById(this.location.storeID).then(response => {
        // console.debug("feedback with store id", response);
        this.feedback = response;
        this.loading = false;
        return response;
      });
    }
  }
};
</script>

<style scoped>
.container.grid-list-lg .layout .flex {
    padding: 0px !important;
}
</style>